import CatalogLink from '@com/seo/CatalogLink';
import NextImage from '@com/_core/NextImage';
import { useGetCategories } from '@api/category/categoryApis.rq';
import { getCategorySlug } from '@utilities/catalog/matchCategory';
import { buildOtcPlpPath } from '@utilities/catalog/paths';

const OtcMedicineCategories = () => {
  const { data, isLoading } = useGetCategories({ level: 1 });

  const renderCategories = () => {
    if (isLoading) {
      return (
        <>
          <div className="w-full px-4 h-[344px] grid grid-cols-2 gap-4">
            {[...Array(6).keys()].map((item, index) => (
              <div
                key={index}
                className="relative h-[104px] flex items-end px-4 py-2 rounded-lg bg-surface-secondary cursor-pointer gap-y-2 animate-pulse"
              ></div>
            ))}
          </div>
        </>
      );
    }

    return (
      <div className="w-full px-4 h-max grid grid-cols-2 gap-4">
        {data?.queryResult?.map((item) => (
          <CatalogLink
            key={item?.categoryCodeLevel1}
            href={buildOtcPlpPath(getCategorySlug(item))}
          >
            <div
              className="relative h-[104px] flex items-end px-4 py-2 rounded-lg bg-surface-secondary cursor-pointer gap-y-2"
            >
              <div className="absolute top-1 left-2 !w-[72px] !h-[72px] flex items-center justify-center overflow-hidden rounded-base">
                {item?.iconLink && (
                  <NextImage
                    src={item?.iconLink}
                    width={72}
                    height={72}
                    alt={item?.categoryNameLevel1}
                    loading="eager"
                  />
                )}
              </div>

              <span className="text-sm w-full  truncate font-medium leading-6 ">
                {item?.categoryNameLevel1}
              </span>
            </div>
          </CatalogLink>
        ))}
      </div>
    );
  };

  return (
    <>
      {renderCategories()}

      <div className="w-full h-auto px-4">
        <div className="!aspect-w-23 !aspect-h-10">
          <NextImage
            src={'/images/otc-medicine-banner.png'}
            alt="fast-order"
            fill
            priority
            sizes="(max-width: 640px) 100vw, 460px"
            style={{ objectFit: 'contain' }}
          />
        </div>
      </div>
    </>
  );
};

export default OtcMedicineCategories;
